export function getLocation() {
   return new Promise((res, rej) => {
      if ('geolocation' in navigator) {
         navigator.geolocation.getCurrentPosition(res, rej)
      } else {
         res(null)
      }
   })
}
